<template>
  <div id="gFooter">Copyright &copy; 2022 Thermaltake Technology Co., Ltd. All Rights Reserved.</div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>
